import React, { createContext, useContext, useMemo } from 'react';
import { getDomain } from '../utils/config';
import { theme, cnTheme } from '../styles/theme';
import { ThemeProvider } from '@material-ui/core';

const ThemeContext = createContext();

const ThemeContextProvider = ({ children }) => {
	const currentDomain = getDomain();
	const lng = new URLSearchParams(window.location.search).get('lng');

	const t = useMemo(() => {
		if (lng === 'cn') return cnTheme;
		switch (currentDomain) {
			case 'onsemi.cn':
				return cnTheme;
			case 'onsemi.com':
				return theme;
			default:
				return theme;
		}
	}, [currentDomain, lng]);

	return (
		<ThemeContext.Provider value={t}>
			<ThemeProvider theme={t}>{children}</ThemeProvider>
		</ThemeContext.Provider>
	);
};

const useThemeContext = () => useContext(ThemeContext);

export { ThemeContextProvider, useThemeContext };
